import PropTypes from "prop-types"
import React from "react"
import { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';

import TableContainer from 'pages/UserPerformanceWithinDates/TableContainerTelecallerPerformance';
import TableContainerVerifier from 'pages/UserPerformanceWithinDates/TableContainerVerifierPerformance';
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getUsersPerformanceWithinDatesAPIURL } from 'BaseComponentAPI/UsersPerformanceWithinDatesAPI';
import { getVeriferPerformanceWithinDatesAPIURL } from 'BaseComponentAPI/UsersPerformanceWithinDatesAPI';
//i18n
import { withTranslation } from "react-i18next"
// import LiveCallsStatsTable from "./LiveCallsStatsTable"
// import SystemCallsStatsTable from "./SystemCallsStatsTable"
// import ColdCallStatsTable from "./ColdCallStatsTable"
// import UserWiseVerificationCallStatsTable from "./UserWiseVerificationCallStatsTable"
// import UserWiseLiveColdStatsTable from "./UserWiseLiveColdStatsTable"
// import UserWiseSysGenratedCallStatsTable from "./UserWiseSysGenratedCallStatsTable"


import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { useLocation, useNavigate } from 'react-router-dom';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import moment from 'moment';

<style>
    {`
  .react-datepicker__triangle {
    left: 50%!important;
    transform: translateX(-50%);
  }
`}
</style>

const UserPerformanceWithinDates = props => {
  
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const navigate = useNavigate();

    const location = useLocation();

    const { fromDate, toDate, triggerFetch = false } = location.state || {};

    // console.log("Received From:", fromDate, "To:", toDate, "triggerFetch:", triggerFetch);

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50];
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);
    const [pendingData, setPendingData] = useState([]);
    const [completedData, setCompletedData] = useState([]);

    const today = new Date();

    const past1Days = new Date();
    past1Days.setDate(today.getDate() - 1);

    const past31Days = new Date();
    past31Days.setDate(today.getDate() - 31);

    const past30Days = new Date();
    past30Days.setDate(today.getDate() - 30);

    const [reportFilters, setReportFilters] = useState({
        fromDate: null,
        toDate: null
    });

    useEffect(() => {
           if (triggerFetch) {
               navigate(location.pathname, { replace: true, state: {} });
           }
       }, []);
   
   const handlePageChange = async (newPageNo, newPageSize) => {

    };

       useEffect(() => {
           if (triggerFetch == true && fromDate && toDate) {
               formik.setFieldValue("startDate", moment(fromDate, "DD/MM/YYYY").toDate());
               formik.setFieldValue("endDate", moment(toDate, "DD/MM/YYYY").toDate());
               //console.log(fromDate + ' - ' + toDate);
               //fetchWorkOrdersData(fromDate, toDate);
              
           }
       }, [triggerFetch]);
   
   
       // Handle date change (for both startDate and endDate)
       const handleDateChange = (date, field) => {
           //setPendingData([]);
           setData([]);
           setVerifierDetails([]);

           if (field === "startDate") {
               setStartDate(date);
           } else {
               setEndDate(date);
           }
           formik.setFieldValue(field, date);
       };
   
       const openPopup = (message, type) => {
           setPopupMessage(message);
           setPopupType(type);
           setIsPopupVisible(true);
       };
   
       const closePopup = () => {
           setIsPopupVisible(false);
       };

    const [data, setData] = useState([]);
    const [verifierDetails, setVerifierDetails] = useState([]);
    const [totalsOfColumn, setTotalOfColumn] = useState({});
        const [totalleads, setTotalLeads] = useState('');
        const [totalWorkOrder, setTotalWorkOrder] = useState('');
        const [totalLost, setTotalLost] = useState('');
        const [totalConversion, setTotalConversion] = useState('');
        const [telecallerPendingCalls, setTelecallerPendingCalls] = useState('');

    const [totalConsumption, setTotalConsumption] = useState('');
    const [totalConnected, setTotalConnected] = useState('');
    const [totalleadsVerifier, setTotalLeadsVerifier] = useState('');
    const [callQuality, setQuality] = useState('');
    const [livePendingCalls, setLivePendingCalls] = useState('');
    


    const telecallerData = useMemo(
            () => [
                {
                    header: "User Name",
                    accessorKey: "userName",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                // {
                //     header: "Last disposition",
                //     accessorKey: "lastDispositionTime",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
    
                // {
                //     header: "P. Sys Calls",
                //     accessorKey: "pendingSysCallCnt",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
    
                {
                    header: "Leads Processed",
                    accessorKey: "liveLeads",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "WO",
                    accessorKey: "workOrders",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "Lost Leads",
                    accessorKey: "lostLeads",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                // {
                //     header: "Followups",
                //     accessorKey: "followups",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
    
                
                {
                    header: "Conversion",
                    accessorKey: "userConversion",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                
                {
                    header: "WO Amt",
                    accessorKey: "totalWOAmount",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                {
                    header: "Avg WO Amt",
                    accessorKey: "perWOCost",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                {
                    header: "Contribution",
                    accessorKey: "userContribution",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                
                
            ],
            []
        );   

    const verifierData = useMemo(
            () => [
                {
                    header: "User Name",
                    accessorKey: "userName",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                // {
                //     header: "Last disposition",
                //     accessorKey: "lastDispositionTime",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
                
                // {
                //     header: "P. Sys Calls",
                //     accessorKey: "pendingSysCallCnt",
                //     enableColumnFilter: false,
                //     enableSorting: true,
                // },
    
                {
                    header: "Consumption",
                    accessorKey: "callConsumption",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "Connected",
                    accessorKey: "connectedCalls",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                {
                    header: "Leads",
                    accessorKey: "leads",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                {
                    header: "Data Quality",
                    accessorKey: "callQuality",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
                
                {
                    header: "Contribution",
                    accessorKey: "userContribution",
                    enableColumnFilter: false,
                    enableSorting: true,
                },
    
                
            ],
            []
        );

   const formik = useFormik({
        initialValues: {
            //startDate: new Date(),
            //endDate: new Date(),
            startDate: past1Days,
            endDate: past1Days,
        },
        validationSchema: Yup.object({
            startDate: Yup.date()
                .required('Start Date is required'),

            endDate: Yup.date()
                .required('End Date is required')
                .test(
                    "date-range",
                    "End Date should not be before Start Date and not more than 30 days later",
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && value) {
                            const diff = moment(value).diff(moment(startDate), "days");

                            // ✅ allow same day (0) up to 5 days later
                            return diff >= 0 && diff < 31;
                        }
                        return true;
                    }
                ),
        }),

        onSubmit: async (values) => {
            //alert('hi');
            setLoaderOption(true);
            setDisableSaveBtn(true);
            //setPendingData([]);
            //setCompletedData([]);
            setData([]);
            setVerifierDetails([]);
            
            if (!authUser.headers || Object.keys(authUser.headers).length == 0) return;

            const startDate = moment(values.startDate).format("DD/MM/YYYY");
            const endDate = moment(values.endDate).format("DD/MM/YYYY");

            // 🔹 Step 1: Fetch work orders first
            //await fetchWorkOrdersData(startDate, endDate);
            setReportFilters({
                    fromDate: startDate,
                    toDate: endDate
                });
            await getData(startDate,endDate); 
            await getVerifierData(startDate,endDate);        
            setDisableSaveBtn(false);
            setLoaderOption(false);
        }


    });



    const getData = async (fromDate, toDate) => {
        setLoaderOption(true);
        setData([]);
        //alert(fromDate + " - "+ toDate);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getDashboardUserWiseVerificationCallStatsAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getUsersPerformanceWithinDatesAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0&startDate=${fromDate}&endDate=${toDate}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalOfColumn(response.data.data.itemsSummary)
                    setTotalLeads(response.data.data.itemsSummary.totalLiveLeads)                    
                    setTotalWorkOrder(response.data.data.itemsSummary.totalWorkOrders)                    
                    setTotalLost(response.data.data.itemsSummary.totalLeadLost)
                    setTotalConversion(response.data.data.itemsSummary.leadConversion)
                    setTelecallerPendingCalls(response.data.data.itemsSummary.telecallerLivePendingCalls)
                    
                    // console.log(response.data.data)

                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', JSON.stringify(error));
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

     const getVerifierData = async (fromDate, toDate) => {
        setLoaderOption(true);
        setVerifierDetails([]);

        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getDashboardUserWiseVerificationCallStatsAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getVeriferPerformanceWithinDatesAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0&startDate=${fromDate}&endDate=${toDate}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setVerifierDetails(response.data.data.items);
                    setTotalOfColumn(response.data.data.itemsSummary);
                    
                    setTotalConsumption(response.data.data.itemsSummary.totalCallConsumption);                    
                    setTotalConnected(response.data.data.itemsSummary.totalConnected)  ;                  
                    setTotalLeadsVerifier(response.data.data.itemsSummary.totalLeads);
                    setQuality(response.data.data.itemsSummary.callQuality);
                    setLivePendingCalls(response.data.data.itemsSummary.livePendingCalls);
                    //setTotalTalkTime(response.data.data.itemsSummary.totalTalkTime)
                    
                    // console.log(response.data.data)

                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', JSON.stringify(error));
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Users")}
            breadcrumbItem={props.t("User Performance Within Dates")}
          />

          <Card>
            <CardBody className="border-bottom">
              <div style={{ padding: '20px' }}>
                <Form onSubmit={formik.handleSubmit}>

                   <Row className='my-3'>
                        {/* From Date Picker */}
                        <Col md="4">
                            <FormGroup>
                                <Label for="startDate">Start Date</Label>

                                <DatePicker
                                    selected={formik.values.startDate}
                                    //selected={past1Days}
                                    onChange={(date) => {
                                        handleDateChange(date, "startDate");
                                        formik.setFieldValue("endDate", null);  // ⭐ MUST BE NULL
                                    }}
                                    minDate={past31Days}   // ❌ Disable dates before 30 days
                                    maxDate={past1Days} 
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Select Start Date"
                                    popperPlacement="bottom"
                                    portalId="root"
                                    renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "8px 12px",
                                                borderBottom: "1px solid #eee",
                                                background: "#fff",

                                            }}
                                        >
                                            <button
                                                onClick={decreaseMonth}
                                                type="button"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ◀
                                            </button>

                                            <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                {date.toLocaleDateString("en-US", {
                                                    month: "long",
                                                    year: "numeric",
                                                })}
                                            </span>

                                            <button
                                                onClick={increaseMonth}
                                                type="button"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ▶
                                            </button>
                                        </div>
                                    )}
                                />


                                {formik.touched.startDate && formik.errors.startDate && (
                                    <div style={{ color: "red", marginTop: "5px" }}>
                                        {formik.errors.startDate}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>


                        {/* To Date Picker */}
                        <Col md="4">
                            <FormGroup>
                                <Label for="endDate">End Date</Label>
                                <DatePicker
                                    selected={formik.values.endDate}
                                    //selected={past1Days}
                                    onChange={(date) => handleDateChange(date, "endDate")}
                                    //minDate={moment(formik.values.startDate).add(1, "days").toDate()}
                                    //maxDate={moment.min(
                                    //        moment(formik.values.startDate).add(2, "days"),
                                    //        moment()
                                    //    ).toDate()
                                    //}
                                    minDate={moment(formik.values.startDate).add(0, "days").toDate()}
                                    maxDate={past1Days} 
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Select End Date"
                                    popperPlacement="bottom"
                                    portalId="root"
                                    renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "8px 12px",
                                                borderBottom: "1px solid #eee",
                                                background: "#fff",
                                            }}
                                        >
                                            <button
                                                onClick={decreaseMonth}
                                                type="button"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ◀
                                            </button>

                                            <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                {date.toLocaleDateString("en-US", {
                                                    month: "long",
                                                    year: "numeric",
                                                })}
                                            </span>

                                            <button
                                                onClick={increaseMonth}
                                                type="button"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ▶
                                            </button>
                                        </div>
                                    )}
                                />
                                {formik.touched.endDate && formik.errors.endDate && (
                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                        {formik.errors.endDate}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className="mt-3">
                        {/* Submit Button */}
                        <Col md="12">
                            <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                Submit
                            </Button>
                        </Col>
                    </Row>
                                        




                    {/* <LiveCallsStatsTable />
                    <SystemCallsStatsTable />
                    <ColdCallStatsTable /> */}
                    {/*<TodaysTelecallerPerformanceTable />
                    <TodaysVerifierPerformanceTable/>
                     */}   
                     {/*
                    <TodaysTelecallerPerformanceTable 
                        key={`${reportFilters.fromDate}-${reportFilters.toDate}`}
                        fromDate={reportFilters.fromDate}
                        toDate={reportFilters.toDate}
                    />*/}
                    {/*
                    <TodaysVerifierPerformanceTable
                        fromDate={reportFilters.fromDate}
                        toDate={reportFilters.toDate}
                    /> */}

                    {/* <UserWiseLiveColdStatsTable />
                    <UserWiseSysGenratedCallStatsTable /> */}

                        {data.length != 0 && (
                            <div className='mt-3'>
                                <h5 className="mt-4" style={{ color: '#b72323' }}>
                                    Telecaller Performance Stats 
                                </h5>
                                <TableContainer
                                    columns={telecallerData}
                                    data={data || []}
                                    isGlobalFilter={false}
                                    isPagination={false}
                                    SearchPlaceholder="Search..."
                                    isCustomPageSize={false}
                                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                    theadClass="table-light"
                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                    pagination="pagination"
                                    getRowProps={row => ({
                                        className: ""
                                    })}
                                    onPageChange={handlePageChange} // Pass page change handler
                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    totalPages={totalPages}
                                    totalItems={totalItems}
                                    tableNextPage={nextPage}
                                    tablePreviousPage={previousPage}
                                    tableCurrentPage={currentPage}
                                    customePageSize={customePageSize}
                                    style={{ maxHeight: "300px", overflowY: 'auto' }}
                                    totalsOfColumn={totalsOfColumn}
                                    totalleads={totalleads}
                                    totalWorkOrder={totalWorkOrder}
                                    totalLost={totalLost}
                                    totalConversion={totalConversion}
                                    telecallerPendingCalls = {telecallerPendingCalls}
                                    
                                />

                        {verifierDetails.length != 0 && (
                            <div className='mt-3'>
                                <h5 className="mt-4" style={{ color: '#b72323' }}>
                                            Verifier Performance Stats
                                        </h5>
                                <TableContainerVerifier
                                    columns={verifierData}
                                    data={verifierDetails || []}
                                    isGlobalFilter={false}
                                    isPagination={false}
                                    SearchPlaceholder="Search..."
                                    isCustomPageSize={false}
                                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                    theadClass="table-light"
                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                    pagination="pagination"
                                    getRowProps={row => ({
                                        className: ""
                                    })}
                                    onPageChange={handlePageChange} // Pass page change handler
                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    totalPages={totalPages}
                                    totalItems={totalItems}
                                    tableNextPage={nextPage}
                                    tablePreviousPage={previousPage}
                                    tableCurrentPage={currentPage}
                                    customePageSize={customePageSize}
                                    style={{ maxHeight: "300px", overflowY: 'auto' }}
                                    totalsOfColumn={totalsOfColumn}

                                    totalConsumption={totalConsumption}
                                    totalConnected={totalConnected}
                                    totalleads={totalleadsVerifier}
                                    callQuality={callQuality}
                                    livePendingCalls = {livePendingCalls}
                                            
                                />

                                    </div>
                                )}
            

                                

                    </div>
                )}



                </Form>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

UserPerformanceWithinDates.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(UserPerformanceWithinDates)
